import PropTypes from 'prop-types'
import React, { Component } from 'react'

import ListEntry from './ListEntry'

export default class ProgramList extends Component {

  static propTypes = {
    collection: PropTypes.array.isRequired,
    fullIndex: PropTypes.bool,
    storeName: PropTypes.string.isRequired,
  }

  render() {

    let lastIndex = null
    const indexedList = this.props.collection.reduce((memo, item) => {
      let sortIndex = '-'
      const sortableValue = item.sortValue
        || item.title
        || item.name
        || '-'
      let renderValue = sortableValue.replace(/ß/g, 'ss')
      try {


        sortIndex = (
          renderValue
        )
          // get sortable characters
          .match(/[-0-9a-zöäü\s]/gi)
          // turn it to a string
          .join('')
          // do some replacements
          .replace(/\s+/g, ' ')
          .replace(/ä/g, 'ae')
          .replace(/ü/g, 'ue')
          .replace(/ö/g, 'oe')
          .replace(/ß/g, 'ss')
          .toUpperCase() || '-'

        if (!this.props.fullIndex) {
          sortIndex = sortIndex[0]
          renderValue = sortIndex
        }
      }
      catch (ex) {
        console.error(ex)
      }
      if (lastIndex !== sortIndex) {
        memo.push({ sortIndex, sortableValue: renderValue })
        lastIndex = sortIndex
      }
      memo.push(item)
      return memo
    }, [])

    return (
      <ul className="tiled-list clearfix scrollable">
        {indexedList.map((entry) => {
          const additionalProps = {}
          if (entry.temporarilyNotBookable) {
            additionalProps.faded = true
            additionalProps.fadedReason = entry.temporarilyNotBookableReason || 'Temporär nicht buchbar'
          }
          if ('sortIndex' in entry) {
            return (
              <li key={`${this.props.storeName}-${entry.sortIndex}`} className="tiled-list-index">
                <strong>{entry.sortableValue}</strong>
              </li>
            )
          }
          return (
            <ListEntry
              key={`${this.props.storeName}-${entry.id}`}
              entry={entry}
              {...additionalProps}
            />
          )
        })}
      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/shared/components/List.js